import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { ServiceAmountsFees } from './serviceamountsfees.model';

@Injectable({
  providedIn: 'root'
})
export class ServicesamountsfeesService {

  constructor(private http: HttpClient, private global: Globle) {

  }


  getAll() {
    return this.http.get<ServiceAmountsFees[]>(this.global.APIURL +
      "serviceamountfees");
  }

  CreateUpdate(serviceAmountFees: any) {
    return this.http.post(this.global.APIURL + "serviceamountfees", serviceAmountFees)
  }
}
